module.exports = __webpack_public_path__ + "img/profile-3.8c25c7aa.png";